import { checkIsNotNullish } from "@tsp-core/utils/nullish";
import { parseUnknownToNumber } from "@tsp-core/utils/number";

import { WorkTypeStatus } from "../enums";
import { WorkTypeId, WorkTypesDictionaryRecord } from "../types";

export function parseWorkTypeId<Input extends unknown>(
  input: Input,
): Input extends WorkTypeId ? WorkTypeId : WorkTypeId | null {
  const id = parseUnknownToNumber(input, "integer");
  if (checkIsNotNullish(id)) {
    return id as WorkTypeId;
  }

  return null as any;
}

export function checkWorkTypeIsActive(record: WorkTypesDictionaryRecord): boolean {
  return record.status === WorkTypeStatus.ACTIVE;
}
